import { Dialog, Transition } from "@headlessui/react";
import React, { Fragment, useState } from "react";
import { UseFormRegister } from "react-hook-form";
import { Trans, useTranslation } from "react-i18next";
type Inputs = any;
interface Props {
  register: UseFormRegister<Inputs>;
  errors: any;
  name: string;
  label: string;
  options: string[] | number[];
  translateId?: string;
  disabled?: boolean;
  i18nKey?: string;
  value?: string;
  printEnabled?: boolean;
}

const SelectAndQmark: React.FC<Props> = ({
  i18nKey,
  register,
  errors,
  name,
  label,
  options,
  translateId,
  disabled,
  value = "",
  printEnabled = false,
}) => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <div className="grid md:grid-cols-2 grid-cols-1 w-full gap-[5px] md:gap-0">
        <label
          htmlFor={`${name}`}
          className="flex flex-wrap font-normal text-xl text-[#1E408E]"
        >
          <Trans t={t}>{label}</Trans>
        </label>
        <div className="relative w-full flex items-center gap-4">
          <div className="grid flex-1">
            <div className="flex flex-row justify-evenly gap-x-4">
              <select
                {...register(`${name}`, { value: value })}
                id={`${name}`}
                className={`w-full h-12 border border-[#8692A6] rounded`}
                defaultValue=""
                disabled={disabled}
              >
                <option value="" disabled hidden>
                  {t(`Select`)}
                </option>
                {options?.map((item, index) => (
                  <option key={index} value={`${item}`}>
                    {t(`${item}`)}
                  </option>
                ))}
              </select>
              {printEnabled && (
                <input
                  type="checkbox"
                  {...register(`print${name}`)}
                  defaultChecked
                  id={`${name}`}
                />
              )}
            </div>
            <p className="text-red-500 text-xs">{errors[name]?.message}</p>
          </div>
          <button
            type="button"
            className="aboslute right-0 text-black"
            onClick={() => setIsOpen(true)}
          >
            <img src="/images/q-mark.svg" alt="guid" />
          </button>
        </div>
      </div>
      <Transition appear show={isOpen} as={Fragment}>
        <Dialog
          as="div"
          className="relative z-10"
          onClose={() => setIsOpen(false)}
        >
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0" />
          </Transition.Child>

          <div className="fixed inset-0 overflow-y-auto">
            <div className="flex min-h-full items-center justify-center p-4 text-center">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <Dialog.Panel className="w-full max-w-md transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all">
                  <Dialog.Title
                    as="h3"
                    className="text-lg font-medium leading-6 text-gray-900"
                  >
                    <Trans i18nKey="Need help">Need help?</Trans>
                  </Dialog.Title>
                  <div className="mt-2">
                    <p className="text-sm text-gray-500">
                      <Trans i18nKey={i18nKey}></Trans>
                    </p>
                  </div>

                  <div className="mt-4">
                    <button
                      type="button"
                      className="inline-flex justify-center rounded-md border border-transparent bg-blue-100 px-4 py-2 text-sm font-medium text-blue-900 hover:bg-blue-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2"
                      onClick={() => setIsOpen(false)}
                    >
                      <Trans i18nKey="got_it">Got it!</Trans>
                    </button>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
    </>
  );
};

export default SelectAndQmark;
